"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsLatLongValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isLatLong(input);
        }
        return false;
    }
}
exports.IsLatLongValidator = IsLatLongValidator;
//# sourceMappingURL=IsLatLongValidator.js.map